import type { MouseEvent } from "react";
import type { User } from "../api";

interface PortalHeaderProps {
  user: User;
  currentPath: string;
  onNavigate(path: string): void;
  onLogout(): void;
}

export function PortalHeader({ user, currentPath, onNavigate, onLogout }: PortalHeaderProps) {
  const follow = (event: MouseEvent<HTMLAnchorElement>, path: string) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onNavigate(path);
  };
  return <header className="portal-header">
    <a className="omr-brand" href="/" onClick={(event) => follow(event, "/")} aria-label="One More Round — главная">
      <strong>OMR<span>_</span></strong>
      <span className="brand-copy"><b>One More Round</b><small>Just one more.</small></span>
    </a>
    <nav aria-label="Основная навигация">
      <a className={currentPath === "/" ? "active" : ""} href="/" onClick={(event) => follow(event, "/")}>Игры</a>
      {user.isAdmin && <a className={currentPath === "/admin" ? "active" : ""} href="/admin" onClick={(event) => follow(event, "/admin")}>Админка</a>}
    </nav>
    <div className="profile-chip">
      <span className={user.subscription ? "badge subscriber" : "badge"}>{user.subscription ? "★ ТЕСТ-ПОДПИСКА" : "ИГРОК"}</span>
      <strong>{user.username}</strong>
      <button className="ghost compact" onClick={onLogout}>выйти</button>
    </div>
  </header>;
}
